import React from 'react';
import { Button } from '../ui/button';

export default function HeroSection() {
  const handleBookTrial = () => {
    const message = encodeURIComponent("Hi! I would like to book a session at COREVA.");
    window.open(`https://wa.me/919129661662?text=${message}`, '_blank');
  };

  const handleExplore = () => {
    document.getElementById('memberships').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" 
        style={{ backgroundImage: 'url("/images/hero-bg.jpg")' }} 
      />
      
      {/* Elegant Overlay */}
      <div className="absolute inset-0 z-10 bg-black/30" />

      {/* Content */}
      <div className="relative z-20 flex flex-col items-center justify-center text-center px-6 max-w-4xl mx-auto pt-20">
        <h1 className="text-5xl md:text-7xl lg:text-8xl text-white font-serif tracking-tight leading-tight mb-6 drop-shadow-lg">
          COREVA
          <span className="block text-2xl md:text-3xl lg:text-4xl mt-4 font-light tracking-widest uppercase text-white/90 font-sans">
            Premium Pilates & Wellness Studio
          </span>
        </h1>

        <p className="text-lg md:text-xl text-white/90 max-w-2xl font-light mb-12 drop-shadow">
          Strengthen your body. Elevate your life.
        </p>

        <div className="flex flex-col sm:flex-row gap-6">
          <Button 
            size="lg" 
            onClick={handleBookTrial}
            className="bg-white text-primary hover:bg-white/90 text-sm md:text-base px-10 py-6 rounded-full transition-transform hover:scale-105 duration-300"
          >
            Book a Session
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            onClick={handleExplore}
            className="bg-transparent text-white border-white hover:bg-white/10 hover:text-white text-sm md:text-base px-10 py-6 rounded-full transition-transform hover:scale-105 duration-300 backdrop-blur-sm"
          >
            Explore Classes
          </Button>
        </div>
      </div>
    </section>
  );
}
